import React, { useState } from 'react'
import { Alert, Button, Form, Modal } from 'react-bootstrap'

function InvestmentSaleModal({ investment, onSubmit, onCancel, error }) {
  const [saleDate, setSaleDate] = useState('')
  const [salePrice, setSalePrice] = useState('')

  function handleSubmit(e) {
    e.preventDefault()
    if (!saleDate || !salePrice) return
    onSubmit({
      sale_date: saleDate,
      sale_quantity: investment.quantity,
      sale_price: parseFloat(salePrice),
    })
  }

  return (
    <Modal show animation={false}>
      <Modal.Header>
        <Modal.Title>Record Sale — {investment.symbol}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-muted mb-3">
          Account: <strong>{investment.account}</strong>
        </p>
        {error && <Alert variant="danger">{error}</Alert>}
        <Form id="sale-form" onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="saleDate">
            <Form.Label>Sale Date</Form.Label>
            <Form.Control
              type="date"
              value={saleDate}
              onChange={(e) => setSaleDate(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="saleQuantity">
            <Form.Label>Sale Quantity</Form.Label>
            <Form.Control
              type="number"
              value={investment.quantity}
              readOnly
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="salePrice">
            <Form.Label>Sale Price</Form.Label>
            <Form.Control
              type="number"
              min="0"
              step="any"
              value={salePrice}
              onChange={(e) => setSalePrice(e.target.value)}
              required
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onCancel}>Cancel</Button>
        <Button variant="primary" type="submit" form="sale-form">Record Sale</Button>
      </Modal.Footer>
    </Modal>
  )
}

export default InvestmentSaleModal
